import React from 'react';
import WaveBg from '../../components/wave-background';
import { useLanguage } from '../../helpers/language-context';
import { Link } from 'react-router-dom';

const ArrowRight = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="5" y1="12" x2="19" y2="12"></line>
        <polyline points="12 5 19 12 12 19"></polyline>
    </svg>
);

const TenderWhistleblower = () => {
    const { translations } = useLanguage();
    return (
        <section className="bg-[#F6F6F6] tender-whistleblower-section">
            <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-8 text-center justify-center items-center mx-auto">
                <div className="p-8 space-y-12 bg-white rounded-lg border-2 border-white group hover:border-[#FDA729] text-start">
                    <div className="text-5xl font-medium text-[#28357B]">
                        {translations.contact.tender.title ?? 'Tender'}
                    </div>
                    <div className="text-sm text-[#444444]">
                        {translations.contact.tender.description ?? 'Tender'}
                    </div>
                    <Link to="/contact/tender" className="flex w-fit items-center justify-center gap-2 bg-[#28357B] text-white group-hover:bg-[#FDA729] group-hover:text-black px-6 py-2 rounded-full transition-colors duration-200">
                        {translations.button.exploreMore ?? 'Explore More'}
                        <ArrowRight />
                    </Link>
                </div>
                <div className="p-8 space-y-12 bg-white rounded-lg border-2 border-white group hover:border-[#FDA729] text-start">
                    <div className="text-5xl font-medium text-[#28357B]">
                        {translations.contact.whistleblower.title ?? 'Speak Up Policy'}
                    </div>
                    <div className="text-sm text-[#444444]">
                        {translations.contact.whistleblower.description ?? 'Speak Up Policy'}
                    </div>
                    <Link to="/governance#whistleblowing" className="flex w-fit items-center justify-center gap-2 bg-[#28357B] text-white group-hover:bg-[#FDA729] group-hover:text-black px-6 py-2 rounded-full transition-colors duration-200">
                        {translations.button.exploreMore ?? 'Explore More'}
                        <ArrowRight />
                    </Link>
                </div>
            </div>

            <div className="absolute left-0 w-full z-0 pointer-events-none">
                <WaveBg color='#28357B' flip={true} />
            </div>
        </section>
    );
};

export default TenderWhistleblower;